import { SettingConst } from '@faire/web-api--source/types';

/**
 * The end date for the holiday spend challenge, on sign up this will be persisted
 */
export const HOLIDAY_SPEND_CHALLENGE_END_DATE =
  'HOLIDAY_SPEND_CHALLENGE_END_DATE' as SettingConst<
    'HOLIDAY_SPEND_CHALLENGE_END_DATE',
    string,
    'RETAILER'
  >;
